import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function ComparisonSection() {
  return <section id="comparison" className="py-8 md:py-12 bg-stone-50" data-id="element-1">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8 md:mb-12" data-id="element-3">
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-stone-900" data-id="element-4">
            O mesmo visual.{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-600 to-emerald-600" data-id="element-5">
              Preços completamente diferentes.
            </span>
          </h2>
        </motion.div>

        {/* Before/After Comparison */}
        <div className="grid grid-cols-2 gap-3 md:gap-8 max-w-5xl mx-auto mb-6 md:mb-10" data-id="element-6">
          {/* ANTES - Before */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2,
          duration: 0.6
        }} className="bg-white rounded-xl md:rounded-3xl shadow-xl overflow-hidden border-2 md:border-4 border-stone-200" data-id="element-7">
            <div className="relative" data-id="element-8">
              <div className="absolute top-2 left-2 md:top-4 md:left-4 bg-red-500 text-white px-2 py-1 md:px-4 md:py-2 rounded-full flex items-center gap-1 md:gap-2 shadow-lg z-10" data-id="element-9">
                <X className="w-3 h-3 md:w-5 md:h-5" data-id="element-10" />
                <span className="font-bold text-xs md:text-sm" data-id="element-11">ANTES</span>
              </div>
              <div className="absolute top-2 right-2 md:top-4 md:right-4 bg-white/90 backdrop-blur-sm text-stone-900 px-2 py-1 md:px-4 md:py-2 rounded-full shadow-lg z-10 text-right" data-id="element-12">
                <span className="font-bold text-sm md:text-lg block leading-none" data-id="element-13">
                  R$ 3,50
                </span>
                <span className="text-xs text-stone-600 block hidden md:block" data-id="element-14">
                  por unidade
                </span>
              </div>
              <img src="https://cdn.magicpatterns.com/uploads/bppScnhU7qGGLbchBUJrmZ/IMG_0361.jpg" alt="Lembrancinha cara - R$ 3,50" className="w-full h-40 md:h-72 object-cover" data-id="element-15" />
            </div>
            <div className="p-3 md:p-6 bg-gradient-to-br from-stone-50 to-stone-100" data-id="element-16">
              <p className="text-stone-700 font-medium text-sm md:text-lg" data-id="element-17">
                Lembrancinha Pronta
              </p>
              <p className="text-stone-600 text-xs md:text-sm mt-0.5 md:mt-1" data-id="element-18">
                Comprada em loja
              </p>
            </div>
          </motion.div>

          {/* DEPOIS - After */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2,
          duration: 0.6
        }} className="bg-white rounded-xl md:rounded-3xl shadow-xl overflow-hidden border-2 md:border-4 border-amber-400" data-id="element-19">
            <div className="relative" data-id="element-20">
              <div className="absolute top-2 left-2 md:top-4 md:left-4 bg-gradient-to-r from-green-500 to-emerald-600 text-white px-2 py-1 md:px-4 md:py-2 rounded-full flex items-center gap-1 md:gap-2 shadow-lg z-10" data-id="element-21">
                <Check className="w-3 h-3 md:w-5 md:h-5" data-id="element-22" />
                <span className="font-bold text-xs md:text-sm" data-id="element-23">DEPOIS</span>
              </div>
              <div className="absolute top-2 right-2 md:top-4 md:right-4 bg-white/90 backdrop-blur-sm text-stone-900 px-2 py-1 md:px-4 md:py-2 rounded-full shadow-lg z-10 text-right" data-id="element-24">
                <span className="font-bold text-sm md:text-lg text-green-600 block leading-none" data-id="element-25">
                  R$ 2,20
                </span>
                <span className="text-xs text-stone-600 block hidden md:block" data-id="element-26">
                  por unidade
                </span>
              </div>
              <img src="https://cdn.magicpatterns.com/uploads/6Vts8euPDFnwXhFqMDdUsF/IMG_0238.jpg" alt="Lembrancinha com Efeito Boutique - R$ 2,20" className="w-full h-40 md:h-72 object-cover" data-id="element-27" />
            </div>
            <div className="p-3 md:p-6 bg-gradient-to-br from-amber-50 to-yellow-50" data-id="element-28">
              <p className="text-stone-900 font-bold text-sm md:text-lg" data-id="element-29">
                Com Efeito Boutique™
              </p>
              <p className="text-stone-700 text-xs md:text-sm mt-0.5 md:mt-1" data-id="element-30">
                Feita em casa
              </p>
            </div>
          </motion.div>
        </div>

        {/* Savings Highlight */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4,
        duration: 0.6
      }} className="flex justify-center" data-id="element-31">
          <div className="bg-gradient-to-r from-green-500 to-emerald-600 text-white px-4 py-3 md:px-8 md:py-4 rounded-2xl shadow-2xl max-w-fit" data-id="element-32">
            <p className="text-lg md:text-2xl font-bold whitespace-nowrap" data-id="element-33">
              Economia de 37% com o Método
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}